import { render, staticRenderFns } from "./icheckbox.vue?vue&type=template&id=d610210a&scoped=true&"
import script from "./icheckbox.vue?vue&type=script&lang=js&"
export * from "./icheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d610210a",
  null
  
)

export default component.exports